export function postsSlider() {
    $(".posts-slider").slick({
        slidesToScroll: 1,
        slidesToShow: 1.065,
        mobileFirst: true,
        infinite: false,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/postsSlider.js